import React, { type ReactNode } from 'react';

import Link from '@atlaskit/link/link';

interface PfLinkProps {
	href: string;
	onClick?: (event: React.MouseEvent) => void;
	id?: string;
	popup?: boolean;
	children: ReactNode;
}

export const PfLink = ({
	href,
	onClick,
	id,
	popup = true,
	children,
}: PfLinkProps): React.JSX.Element => (
	<Link
		href={href}
		id={id}
		rel={popup ? 'noreferrer noopener' : undefined}
		target={popup ? '_blank' : undefined}
		onClick={onClick}
	>
		{children}
	</Link>
);
